<template>
  <article class="advance-card">
    <div class="advance-card__header">
      <div>
        <cabinet-status :status="advance.status" />
        <h3>{{ formatMoney(advance.amount, advance.currency) }}</h3>
      </div>
      <strong>{{ formatMonth(advance.payroll_month) }}</strong>
    </div>
    <cabinet-rows :rows="rows" />
    <button v-if="advance.deductions.length" class="advance-card__disclosure" type="button" @click="expanded = !expanded">
      {{ expanded ? $t('common.hideDeductions') : $t('common.deductionsCount', { count: advance.deductions.length }) }}
    </button>
    <cabinet-schedule v-if="expanded" :items="deductions" />
    <app-button v-if="['requested', 'approved'].includes(advance.status.code)" class="btn--stretch advance-card__button" theme="error" @click.native="$emit('cancel', advance)">
      {{ $t('common.cancelRequest') }}
    </app-button>
  </article>
</template>

<script>
import CabinetRows from './CabinetRows'
import CabinetSchedule from './CabinetSchedule'
import CabinetStatus from './CabinetStatus'
import { formatDate, formatMoney, formatMonth, formatPercent } from './cabinetDisplay'

export default {
  name: 'AdvanceCard',
  components: { CabinetRows, CabinetSchedule, CabinetStatus },
  props: {
    advance: { type: Object, required: true },
  },
  data() {
    return { expanded: false }
  },
  computed: {
    rows() {
      const rows = [
        { label: this.$t('finance.payrollMonth'), value: formatMonth(this.advance.payroll_month) },
        { label: this.$t('common.requested'), value: formatDate(this.advance.created_at) },
        { label: this.$t('finance.netPayAfter'), value: formatPercent(this.advance.net_pay_percent_after) },
      ]
      if (this.advance.employee_notes) rows.push({ label: this.$t('common.note'), value: this.advance.employee_notes })
      if (this.advance.rejection_reason) rows.push({ label: this.$t('finance.rejectionReason'), value: this.advance.rejection_reason })
      return rows
    },
    deductions() {
      return this.advance.deductions.map(item => ({
        month: item.payroll_month ? formatMonth(item.payroll_month) : this.$t('common.upcoming'),
        status: item.status,
        amount: formatMoney(item.amount, this.advance.currency),
      }))
    },
  },
  methods: { formatMoney, formatMonth },
}
</script>

<style lang="sass" scoped>
.advance-card
  padding: 20px
  border: 1px solid #e5e5e5
  border-radius: 14px

.advance-card + .advance-card
  margin-top: 16px

.advance-card__header
  display: flex
  justify-content: space-between
  gap: 14px

  h3
    margin-top: 9px
    color: #202020
    font-size: 21px
    font-weight: 600

  > strong
    color: #4f8d12
    font-size: 18px
    font-weight: 600

.advance-card__disclosure
  margin-top: 14px
  color: #4f8d12
  font-size: 14px
  font-weight: 600

.cabinet-schedule,
.advance-card__button
  margin-top: 14px
</style>
